import { render } from "./StoryViolate.vue?vue&type=template&id=055e9b72"
import script from "./StoryViolate.vue?vue&type=script&lang=js"
export * from "./StoryViolate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__